import styled from 'styled-components'

export const Container = styled.div`
  background-color: #F6F6FA;
  box-shadow: 0px 10px 20px 0px #00000040;
  border-radius: 24px;
  padding: 32px 24px;
  height: 80vh;
  max-width: 668px;
  width: calc(100vw - 64px);
`

export const Article = styled.article`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  overflow-y: auto;

  & > header {
    display: flex;
    flex-direction: column;
    gap: 8px;

    & > h1 {
      font-size: 1.5rem;
      text-align: center;
      text-decoration: underline;
    }

    & > h2 {
      font-size: 1.25rem;
      text-align: center;
    }

    & > p {
      font-size: 1rem;
      margin-top: 8px;
    }
  }

  ol {
    list-style: none;
    padding-block: 0.5em;

    li {
      margin-bottom: 0.5em;
      text-align: justify;

      & > span {
        &.item-header {
          font-size: 1.125rem;
          font-weight: 700;
          margin-bottom: 0.5em;
        }

        &.highlight {
          background-color: #FFFF00;
        }
      }

      & > ol > li > ol > li {
        padding-left: 1em;
      }
    }
  }

  & > footer {
    display: flex;
    flex-direction: column;
    gap: 32px;

    & > p {
      font-size: 1rem;
      font-weight: 400;
    }

    & > section {
      & > p {
        font-size: 1rem;
        text-align: justify;
      }
    }
  }

`
